import Layout from '@/views/layout'

const adminRouter = [{
  path: '/admin',
  component: Layout,
  children: [{
    path: 'index',
    name: 'Project',
    meta: {title: '项目管理', module: 'admin', icon: 'project'},
    component: () => import('@/views/admin/Project')
  }]
}, {
  path: '/admin/dev',
  component: Layout,
  children: [{
    path: 'index',
    name: 'Dev',
    meta: {title: '机台管理', module: 'admin', icon: 'machine'},
    component: () => import('@/views/admin/Dev')
  }]
}, {
  path: '/admin/spectrum',
  component: Layout,
  children: [{
    path: 'index',
    name: 'AdminSpectrum',
    meta: {title: '色谱柱管理', module: 'admin', icon: 'spectrum'},
    component: () => import('@/views/admin/Spectrum')
  }]
}, {
  path: '/admin/team',
  component: Layout,
  children: [{
    path: 'index',
    name: 'AdminTeam',
    meta: {title: '团队管理', module: 'admin', icon: 'team'},
    component: () => import('@/views/admin/Team')
  }]
}, {
  path: '/admin/fee',
  component: Layout,
  children: [{
    path: 'index',
    name: 'AdminFee',
    meta: {title: '计费管理', module: 'admin', icon: 'fee'},
    component: () => import('@/views/admin/Fee')
  }]
}]

export default adminRouter
